import React from 'react';
import { Heart, TrendingUp, Shield, Star, Home, Briefcase } from 'lucide-react';

const ServicesSection = () => {
  const services = [
    {
      icon: <Heart size={40} />,
      title: 'Retour affectif rapide',
      description: 'Retrouvez l\'être aimé, réconciliation amoureuse, envoûtement amoureux, résultats rapides et garantis'
    },
    {
      icon: <TrendingUp size={40} />,
      title: 'Mariage et union',
      description: 'Réussite dans le mariage, union durable, protection du couple, harmonie conjugale'
    },
    {
      icon: <Shield size={40} />,
      title: 'Protection contre mauvais œil',
      description: 'Protection puissante contre le mauvais œil, malédictions, énergies négatives et jalousie'
    },
    {
      icon: <Star size={40} />,
      title: 'Voyance et médiumnité',
      description: 'Prédictions précises, consultation de voyance, révélation de l\'avenir, guidance spirituelle'
    },
    {
      icon: <Home size={40} />,
      title: 'Permis de construire',
      description: 'Aide spirituelle pour obtention de permis de construire, succès dans vos projets immobiliers'
    },
    {
      icon: <Briefcase size={40} />,
      title: 'Chance et réussite',
      description: 'Chance aux jeux, réussite professionnelle et financière, attirer la prospérité'
    }
  ];

  return (
    <section id="services" className="services-section">
      <div className="services-container">
        <div className="services-header">
          <div className="section-icon">✨</div>
          <h2>Mes Services Spirituels</h2>
          <p className="services-subtitle">
            Un accompagnement personnalisé pour tous vos besoins spirituels
          </p>
        </div>

        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-icon">
                {service.icon}
              </div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;